module.exports = __webpack_public_path__ + "assets/goals-desktop.8c35873cb5742797789da1b846e55959.png";